<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <button
          class="btn btn-outline-primary me-3"
          data-bs-toggle="modal"
          data-bs-target="#addStudent"
        >
          {{ 'Add student' | translate }}
        </button>
        <div
          class="modal fade"
          id="addStudent"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          ref="addStudentModal"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {{ 'Add student' | translate }}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label for="name">{{ 'First name' | translate }}</label>
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    v-model="newStudent.name"
                  />
                </div>
                <div class="mb-3">
                  <label for="email">{{ 'Email' | translate }}</label>
                  <input
                    type="text"
                    id="email"
                    class="form-control"
                    v-model="newStudent.email"
                  />
                </div>
                <p>
                  <small class="text-muted">
                    {{
                      'Our system is going to send an email with login credentials few minutes after clicking the add button'
                        | translate
                    }}.
                  </small>
                  <small class="text-muted">
                    {{
                      'Reload the page to see the student on the students list'
                        | translate
                    }}.
                  </small>
                </p>
                <p>
                  <small class="text-muted">
                    {{
                      'The student has agreed to the terms and privacy policy of my platform'
                        | translate
                    }}.
                  </small>
                </p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {{ 'Cancel' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addStudent"
                >
                  {{ 'Add' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn btn-outline-primary"
          data-bs-toggle="modal"
          data-bs-target="#importStudents"
        >
          {{ 'Import students' | translate }}
        </button>
        <div
          class="modal fade"
          id="importStudents"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          ref="importStudentsModal"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {{ 'Import students' | translate }}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label for="multipleStudentsField">
                    {{ 'First name' | translate }}, {{ 'email' | translate }}
                  </label>
                  <textarea
                    id="multipleStudentsField"
                    class="form-control"
                    v-model="importString"
                  ></textarea>
                  <small class="text-muted">
                    {{ 'Max: 50 emails' | translate }}.
                    {{ 'Example:' | translate }}
                  </small>
                  <code>
                    <pre>
Jon, example@email.com
Jane, example2@email.com</pre
                    >
                  </code>
                </div>
                <p>
                  <small class="text-muted">
                    {{
                      'Our system is going to send an email with login credentials few minutes after clicking the add button'
                        | translate
                    }}.
                  </small>
                  <small class="text-muted">
                    {{
                      'Reload the page to see the student on the students list'
                        | translate
                    }}.
                  </small>
                </p>
                <p>
                  <small class="text-muted">
                    {{
                      'The student has agreed to the terms and privacy policy of my platform'
                        | translate
                    }}.
                  </small>
                </p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {{ 'Cancel' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="importStudents"
                >
                  {{ 'Add' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end">
        <ExportCSV link="/home/students/export"></ExportCSV>
      </div>
    </div>

    <div class="card border-0 bg-light my-4">
      <div class="card-body d-flex justify-content-around">
        <div class="text-center">
          <h2 class="m-0">
            {{ students.total }}
          </h2>
          <small class="text-uppercase">
            {{ 'Students' | translate }}
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            aria-label="Example text with button addon"
            aria-describedby="button-addon1"
            :placeholder="$t('Search by email')"
            v-model="filters.search_string"
            @keydown.enter="filterBy('search_string', filters.search_string)"
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              id="button-addon1"
              @click="filterBy('search_string', filters.search_string)"
            >
              {{ 'Search' | translate }}
            </button>
            <button
              class="btn btn-outline-secondary"
              type="button"
              id="button-addon2"
              v-if="filters.search_string !== ''"
              @click="filterBy('search_string', '')"
            >
              X
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12 col-lg-6 d-flex">
        <div>
          <button
            ref="pick"
            class="btn"
            :class="{
              'btn-outline-primary': filters.date !== '',
              'btn-outline-secondary': filters.date === '',
            }"
          >
            {{ 'Date' | translate }}
          </button>
          <button
            class="btn btn-outline-primary"
            v-if="filters.date !== ''"
            @click="clearPickr"
          >
            X
          </button>
        </div>

        <div class="dropdown ms-3" v-if="affiliate_codes.length > 1">
          <button
            class="btn"
            :class="{
              'btn-outline-secondary': filters.affiliate_code === '',
              'btn-outline-primary': filters.affiliate_code !== '',
            }"
            type="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span>{{ 'Affiliate Codes' | translate }}</span>
            <span v-if="filters.affiliate_code !== ''">
              : {{ filters.affiliate_code }}
            </span>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              class="dropdown-item"
              href="#"
              v-for="code in affiliate_codes"
              :key="code"
              @click.prevent="filterBy('affiliate_code', code)"
            >
              {{ code || 'All' | translate }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <Select
          inputId="courses"
          v-model="filters.course"
          autocomplete="off"
          :reduce="(c) => c.id"
          label="title"
          :options="courses"
          @input="setSelected"
          :clearable="false"
        ></Select>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="table">
          <thead>
            <tr>
              <th class="border-0 text-uppercase">{{ 'Email' | translate }}</th>
              <th class="border-0 text-uppercase">{{ 'Name' | translate }}</th>
              <th class="border-0 text-uppercase"></th>
              <th
                v-if="filters.course === 'subscription'"
                class="border-0 text-uppercase"
              >
                {{ 'Membership' | translate }}
              </th>
              <th
                class="border-0 text-uppercase"
                v-if="affiliate_codes.length > 1"
              >
                {{ 'Affiliate' | translate }}
              </th>
              <th class="border-0 text-uppercase text-end">
                {{ 'Created at' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!students.data.length">
              <td colspan="7">
                <div class="col text-center">
                  <img
                    class="w-25 mt-5 mb-3"
                    src="/images/undraw_empty_xct9.svg"
                    alt=""
                  />
                  <h3 class="fw-light">
                    {{ 'Oops... No students yet' | translate }}
                  </h3>
                </div>
              </td>
            </tr>
            <tr v-for="student in students.data" :key="student.id">
              <td>
                <a :href="`/home/students/${student.id}`">
                  {{ student.email }}
                </a>
              </td>
              <td>{{ student.name }}</td>
              <td>
                <span v-if="student.vat_number">
                  <i class="far fa-building"></i>
                </span>
                <span v-else><i class="far fa-user"></i></span>
              </td>

              <td
                v-if="filters.course === 'subscription' && student.membership"
                :class="{
                  'text-danger':
                    student.membership.internal_note === 'delete_after_end',
                  'text-success': !student.membership.internal_note,
                }"
              >
                {{ student.membership.ends_at }}
              </td>
              <td v-if="affiliate_codes.length > 1">
                {{ student.affiliate_outer }}
              </td>
              <td class="text-end">{{ humanDate(student.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <button
      class="btn btn-outline-secondary btn-sm"
      @click="previousPage"
      v-if="students.prev_page_url"
    >
      {{ 'Previous' | translate }}
    </button>
    <button
      class="btn btn-outline-secondary btn-sm"
      @click="nextPage"
      v-if="students.next_page_url"
    >
      {{ 'Next' | translate }}
    </button>
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import _ from 'lodash'
import Select from 'vue-select'
import ExportCSV from './ExportCSV'
import pp from 'papaparse'
import dayjs from 'dayjs'

export default {
  components: {
    Select,
    ExportCSV,
  },
  data() {
    return {
      importString: '',
      newStudent: {
        name: null,
        email: null,
      },
      students: {
        total: 0,
        data: [],
        current_page: 1,
        last_page: 1,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: 'https://skyier.com/home/students',
      },
      picker: null,
      fromto: null,
      promo_codes: [],
      affiliate_codes: [],
      loading: false,
      filters: {
        search_string: '',
        course: '',
        affiliate_code: '',
        date: '',
        membership: '',
      },
    }
  },
  methods: {
    humanDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    addStudent() {
      axios
        .post('/home/students/add', this.newStudent)
        .then((result) => {
          return true
        })
        .then(() => {
          this.importStudentsModal.hide()

          this.newStudent = {
            name: null,
            email: null,
          }
          iziToast.success({
            title: 'OK',
            message: this.$t('Added'),
            position: 'bottmLeft',
          })
        })
        .catch(this.handleErrors)
    },
    importStudents() {
      let parsed = pp.parse(this.importString, {
        skipEmptyLines: true,
        transform: (val) => {
          return _.trim(val)
        },
        preview: 50,
      })

      axios
        .post('/home/students/import', { data: parsed.data })
        .then((result) => {
          this.importStudentsModal.hide()
          this.imimportString = ''
          iziToast.success({
            title: 'OK',
            message: this.$t('Added'),
            position: 'bottmLeft',
          })

          return this.index()
        })
        .then(this.replaceAllData)
        .then(() => {
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    clearPickr() {
      this.filterBy('date', '')
    },
    setSelected(value) {
      this.filterBy('course', value)
    },
    index() {
      this.loading = true
      return this.$api.student.index(this.filters)
    },
    nextPage() {
      this.filters.page = this.students.current_page + 1
      this.index()
        .then(this.replaceStudents)
        .then(() => {
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    previousPage() {
      this.filters.page = this.students.current_page - 1
      this.index()
        .then(this.replaceStudents)
        .then(() => {
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    handleErrors(error) {
      console.error(error)
    },
    replaceAllData(response) {
      this.affiliate_codes = _.sortBy(response.data.affiliate_codes).reverse()
      this.students = response.data.students
      return true
    },
    replaceData(response) {
      this.students = response.data.students
      return true
    },
    replaceStudents(response) {
      this.students = response.data.students
      return true
    },

    filterBy(key, value) {
      if (!value) {
        value = ''
      }

      this.filters.page = 1
      this.filters[key] = value

      if (key === 'date') {
        this.picker.input.innerText = 'Date: ' + value.replace('to', '/')
      }

      this.index()
        .then(this.replaceData)
        .then(() => {
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    initiatePicker(locale) {
      let that = this
      this.picker = flatpickr(this.$refs.pick, {
        locale: locale === 'pl' ? Polish : null,
        mode: 'range',
        onValueUpdate(selectedDate, dateString, instance) {
          if (selectedDate.length === 2) {
            that.filterBy('date', dateString.replace('do', 'to'))
          }
        },
      })
    },
    getCourses() {
      this.$api.json
        .courses()
        .then(({ data }) => {
          this.$store.commit('coursesUpdate', data)
        })
        .catch(this.handleErrors)
    },
  },
  mounted() {
    this.importStudentsModal = new bootstrap.Modal(
      this.$refs.importStudentsModal,
    )
    this.addStudent = new bootstrap.Modal(this.$refs.addStudentModal)
    this.initiatePicker(this.$i18n.locale())
    this.index()
      .then(this.replaceAllData)
      .then(() => {
        this.loading = false
      })
      .catch(this.handleErrors)
    this.getCourses()
  },
  computed: {
    courses() {
      return [
        {
          title: this.$t('No course filter'),
          id: '',
        },
        {
          title: this.$t('Subscription'),
          id: 'subscription',
        },
        ...this.$store.state.courses,
      ]
    },
  },
}
</script>
